import { RootElement } from '@typedream/components';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_ROOT } from '../../pluginKeys';
import { withRoot } from './withRoot';

export const createRootPlugin = createTElementPluginFactory({
  key: ELEMENT_ROOT,
  component: RootElement,
  withOverrides: withRoot,
});
